import { TrackableEntity } from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import { FileLockProp, InvoiceBillCrdb } from '../ifmsTypes';
import _ from 'lodash';
import { BtLoadDetail } from './BtLoadDetail';
import { BtLoadDetailOrder } from './BtLoadDetailOrder';

export class BtLoad extends TrackableEntity {
    id: number = 0;
    loadNo: string = '';
    loadDate: string | null = null;
    carrier: number = 0;
    carrierName: string = '';
    broker: number = 0;
    brokerName: string = '';
    owner: number = 0;
    ownerName: string = '';
    loadSize: string = '';
    driver: string = '';
    driver2: string = '';
    truckNo: string = '';
    vanNo: string = '';
    departure: string | null = null;
    departed: boolean = false;
    completedDate: string | null = null;
    completed: boolean = false;
    actClosed: boolean = false;
    actClosedBy: string = '';
    actCloseDate: string | null = null;
    isClosed: boolean = false;
    fileClosed: number = 0;
    closedBy: string = '';
    closeDate: string | null = null;
    u1Id: string = '';
    u2Id: string = '';
    u1Date: string | null = null;
    u2Date: string | null = null;
    remark: string = '';
    draft: boolean = true;
    trackingNo: string = '';
    sharedURL: string = '';
    branch: string = '';
    confirmDate: string | null = null;
    confirmedBy: string = '';
    confirmActionDate: string | null = null;

    loadDetailList: BtLoadDetail[] = [];
    loadOrderList: BtLoadDetailOrder[] = [];

    profitShare: number = 0;
    invoiceBill:InvoiceBillCrdb|null = null;
    
    statusInvo: string = '';
    statusBill: string = '';
    statusCrdb: string = '';

    completeBill: string = '';
    completeInvo: string = '';
    completeCrdb: string = '';

    searchOrderId: string = ''; // Not Save. Edit, View 모드로 열었을 때 해당 데이터의 Order가 Lookup에 표시하기 위해 추가

    // For RtdShipInfo
    shipmentId: string = '';
    shipFrom: string = '';
    shipTo: string = '';
    departureUtc: string | null = null;
    fromTZOffset: number = 0;
    currentLoc: string = '';
    etaUtc: string | null = null;
    currentEtaUtc: string | null = null;
    toTZOffset: number = 0;
    distanceLeft: number = 0;
    completedUtc: string | null = null;

    isFileLockFor(propName: string) {
        return this.isClosed && !BtLoad.fileLockEnableProps.some(x => x.key === propName);
    }

    static getFileLockMessage(): string {
        return 'Op Close';
    }
    
    static fileLockEnableProps: FileLockProp[] = [
        { key: '', name: '' },
    ];

    constructor(init?:Partial<BtLoad>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'invoiceBill', 'fileClosed', 'closedBy', 'closeDate', 'isClosed', 'actClosed', 'actClosedBy', 'actCloseDate', 'confirmDate', 'confirmedBy', 'searchOrderId');
        this.getdateProps.push('u1Date', 'u2Date'); 
        if(this.id === 0) this.id = this.GetNextId();

        if(this.loadDetailList.length > 0){
            this.loadDetailList = this.loadDetailList.map(d => new BtLoadDetail(d));
        } else {
            this.loadDetailList = [];
        }

        if(this.loadOrderList.length > 0){
            this.loadOrderList = this.loadOrderList.map(d => new BtLoadDetailOrder(d));
        } else {
            this.loadOrderList = [];
        }
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(BtLoad.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = BtLoad.dicFieldMappings[m];
        });

        _.keys(BtLoadDetail.dicFieldMappings).forEach(m=>{
            dicFieldMap[`loadDetailList.${m}`] = BtLoadDetail.dicFieldMappings[m];
        });

        _.keys(BtLoadDetailOrder.dicFieldMappings).forEach(m=>{
            dicFieldMap[`loadOrderList.${m}`] = BtLoadDetailOrder.dicFieldMappings[m];
        });
        return dicFieldMap;
    }

    setChildTrackable(value: boolean): void {
        if(this.loadDetailList.length > 0) {
            this.loadDetailList.forEach(c => c.trackable = value);
        }

        if(this.loadOrderList.length > 0) {
            this.loadOrderList.forEach(c => c.trackable = value);
        }
    }

    get canChangeBranch():boolean {
        // if (this.id <= 0) {
            return true;
        // }

        // const allowedStatuses = ['', 'E', 'D'];
        // return allowedStatuses.includes(this.statusBill) &&
        //     allowedStatuses.includes(this.statusInvo)
    };

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_BTLOAD' }),
        'loadNo': new DBMappingInfo({ field: 'F_LoadNo', table: 'T_BTLOAD' }),
        'loadDate': new DBMappingInfo({ field: 'F_LoadDate', table: 'T_BTLOAD' }),
        'carrier': new DBMappingInfo({ field: 'F_Carrier', table: 'T_BTLOAD' }),
        'broker': new DBMappingInfo({ field: 'F_Broker', table: 'T_BTLOAD' }),
        'owner': new DBMappingInfo({ field: 'F_Owner', table: 'T_BTLOAD' }),
        'loadSize': new DBMappingInfo({ field: 'F_LoadSize', table: 'T_BTLOAD' }),
        'driver': new DBMappingInfo({ field: 'F_Driver', table: 'T_BTLOAD' }),
        'driver2': new DBMappingInfo({ field: 'F_Driver2', table: 'T_BTLOAD' }),
        'truckNo': new DBMappingInfo({ field: 'F_TruckNo', table: 'T_BTLOAD' }),
        'vanNo': new DBMappingInfo({ field: 'F_VanNo', table: 'T_BTLOAD' }),
        'departure': new DBMappingInfo({ field: 'F_Departure', table: 'T_BTLOAD' }),
        'departed': new DBMappingInfo({ field: 'F_Departed', table: 'T_BTLOAD' }),
        'completedDate': new DBMappingInfo({ field: 'F_CompletedDate', table: 'T_BTLOAD' }),
        'completed': new DBMappingInfo({ field: 'F_Completed', table: 'T_BTLOAD' }),
        'fileClosed': new DBMappingInfo({ field: 'F_FileClosed', table: 'T_BTLOAD' }),
        'closedBy': new DBMappingInfo({ field: 'F_ClosedBy', table: 'T_BTLOAD' }),
        'closeDate': new DBMappingInfo({ field: 'F_CloseDate', table: 'T_BTLOAD' }),
        'u1Id': new DBMappingInfo({ field: 'F_U1ID', table: 'T_BTLOAD' }),
        'u2Id': new DBMappingInfo({ field: 'F_U2ID', table: 'T_BTLOAD' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1Date', table: 'T_BTLOAD' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_BTLOAD' }),
        'remark': new DBMappingInfo({field: 'F_Remark', table: 'T_BTLOAD'}),
        'draft': new DBMappingInfo({field:'F_Draft', table: 'T_BTLOAD'}),
        'trackingNo': new DBMappingInfo({field:'F_TrackingNo', table: 'T_BTLOAD'}),
        'shipmentId': new DBMappingInfo({field:'F_SharedURL', table: 'T_BTLOAD'}),
        'branch': new DBMappingInfo({field:'F_BRANCH', table: 'T_BTLOAD'}),
        'completeBill': new DBMappingInfo({ field: 'F_COMPLETEBILL', table: 'T_BTLOAD' }),
        'completeInvo': new DBMappingInfo({ field: 'F_COMPLETEINVO', table: 'T_BTLOAD' }),
        'completeCrDb': new DBMappingInfo({ field: 'F_COMPLETECRDB', table: 'T_BTLOAD' }),
    };
}
